import { Vue, Component } from 'vue-property-decorator';
import { OrganizationDTO } from '@/models';
import { fetchOrganizations } from '@/services';
import { startCase, toLower } from 'lodash';

@Component
export default class OrgInformation extends Vue {
  $refs!: {
    formRef: HTMLFormElement;
  };
  private organization = {} as OrganizationDTO;

  async mounted(): Promise<void> {
    await fetchOrganizations().then(payload => {
      const organizations = payload.data;
      this.organization = organizations[0];
    });
  }
}
